import React, { useContext, useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import "./ProjectDetails.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Documents } from "./Documents";
import Payment from "./Payment";
import Members from "./Members";
import Updates from "./Updates";
import Milestone from "./Milestone";
import Dashbord from "./Dashbord";
import TaskList from "./ProjectTask/TaskList";
import TasksRequest from "./ProjectTask/TasksRequest";
import { deleteRequest, getRequest } from "../../../components/axiosClient";
import {
  DELETE_ALL_PROJECT,
  GET_PROJECT_PENDING_REQUEST_COUNT,
} from "../../../components/utils";
import {
  errorNotification,
  successNotification,
} from "../../../components/toast-notification/common-toast";
import { boundaryContext } from "../../../App";
import { Note } from "./Note";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Popover,
} from "@mui/material";
import deleteIcon from "../../../components/assets/bin.svg";
import NewModal from "../Modal/NewModal";

const ProjectDetails = () => {
  const navigate = useNavigate();
  const id = useParams();
  const role_accesses =
    JSON.parse(secureLocalStorage.getItem("role_accesses")).find(
      (access) => access.module.name === "Projects"
    )?.access_type !== "Read";
  const role = secureLocalStorage.getItem("role");
  const [activeTab, setActiveTab] = useState("tasks");
  const [count, setCount] = useState();
  const { setProjectName } = useContext(boundaryContext);
  const [showModal, setShowModal] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const updateActiveTab = (tab) => {
    if (tab === activeTab) {
      return;
    }
    const currentParams = Object.fromEntries(searchParams.entries());
    const updatedParams = {
      ...currentParams,
      tab: tab,
    };
    setSearchParams(new URLSearchParams(updatedParams), { replace: true });
  };

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab) {
      setActiveTab(tab);
    } else {
      updateActiveTab(secureLocalStorage.getItem("activeTab") || "tasks");
    }
    getRequestCount();
  }, [searchParams]);

  // useEffect(() => {
  //   const savedTab = secureLocalStorage.getItem("activeTab");
  //   if (savedTab) {
  //     setActiveTab(savedTab);
  //   } else {
  //     setActiveTab("dashboard");
  //   }
  //   getRequestCount();
  // }, []);

  const getRequestCount = async () => {
    try {
      const res = await getRequest(
        `${GET_PROJECT_PENDING_REQUEST_COUNT}?project_id=${id.id}`,
        null,
        navigate
      );
      if (res.type === 2) {
        errorNotification(res.errormessage);
      } else {
        setCount(res.data.data.pendingRequest);
        setProjectName(res?.data?.data?.project_name);
      }
    } catch (error) {
      errorNotification(error);
    }
  };

  useEffect(() => {
    if (activeTab) {
      secureLocalStorage.setItem("activeTab", activeTab);
    }
  }, [activeTab]);

  // Handle tab change
  const handleTabChange = (e) => {
    updateActiveTab(e.target.name);
  };

  // Navigate to previous page
  const goBack = () => {
    navigate(-1);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const ids = open ? "simple-popover" : undefined;

  const handleDeleteClick = () => {
    setShowModal(true);
    console.log(id.id);
  };

  const confirmDelete = async () => {
    try {
      const res = await deleteRequest(
        `${DELETE_ALL_PROJECT}?project_id=${id.id}`,
        null,
        navigate
      );
      if (res.type === 1) {
        successNotification(res.response.data.message);
        setShowModal(false);
        goBack();
      } else if (res.type === 2) {
        errorNotification(res.errormessage || res.errors);
      }
    } catch (error) {
      console.error("Error removing task: ", error);
    }
  };

  return (
    <div className="admin__program__manage admin__program__details__section admin_audit h-full flex flex-col">
      <div className="flex justify-between">
        <div className="go__back__btn cursor-pointer flex justify-start items-center mb-3 gap-2">
          <ArrowBackIcon onClick={goBack} loading="lazy" />
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            {/* <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "dashboard" ? "active" : ""
              }`}
              id="pills-dashboard-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-dashboard"
              type="button"
              role="tab"
              aria-controls="pills-dashboard"
              aria-selected="true"
              onClick={(e) => handleTabChange(e)}
              name="dashboard"
            >
              Dashboard
            </button>
          </li> */}
            {/* <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "daily-updates" ? "active" : ""
              }`}
              id="pills-daily-updates-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-daily-updates"
              type="button"
              role="tab"
              aria-controls="pills-daily-updates"
              aria-selected="false"
              name="daily-updates"
              onClick={(e) => handleTabChange(e)}
            >
              Daily updates
            </button>
          </li> */}
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "tasks" ? "active" : ""}`}
                id="pills-tasks-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-tasks"
                type="button"
                role="tab"
                aria-controls="pills-tasks"
                aria-selected="false"
                name="tasks"
                onClick={(e) => handleTabChange(e)}
              >
                Tasks
              </button>
            </li>
            {/* {role_accesses && (
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "milestone" ? "active" : ""
                }`}
                id="pills-milestone-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-milestone"
                type="button"
                role="tab"
                aria-controls="pills-milestone"
                aria-selected="false"
                name="milestone"
                onClick={(e) => handleTabChange(e)}
              >
                Milestone
              </button>
            </li>
          )} */}
            {/* {(role_accesses ||
            role === "Business development manager" ||
            role === "Business development executive") && (
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "payment" ? "active" : ""
                }`}
                id="pills-payment-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-payment"
                type="button"
                role="tab"
                aria-controls="pills-payment"
                aria-selected="false"
                name="payment"
                onClick={(e) => handleTabChange(e)}
              >
                Payment
              </button>
            </li>
          )} */}
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "documents" ? "active" : ""
                }`}
                id="pills-documents-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-documents"
                type="button"
                role="tab"
                aria-controls="pills-documents"
                aria-selected="false"
                name="documents"
                onClick={(e) => handleTabChange(e)}
              >
                Documents
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "members" ? "active" : ""
                }`}
                id="pills-members-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-members"
                type="button"
                role="tab"
                aria-controls="pills-members"
                aria-selected="false"
                name="members"
                onClick={(e) => handleTabChange(e)}
              >
                Members
              </button>
            </li>
            {/* {role_accesses && (
            <li className="nav-item text-center" role="presentation">
              <button
                className={`nav-link ${
                  activeTab === "task-request" ? "active" : ""
                }`}
                id="pills-task-request-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-task-request"
                type="button"
                role="tab"
                aria-controls="pills-task-request"
                aria-selected="false"
                name="task-request"
                onClick={(e) => handleTabChange(e)}
              >
                Task Request
                {count > 0 && (
                  <span className="bg-red-500 inline-block text-white rounded-full h-4 w-4 text-center text-xs ml-1">
                    {count}
                  </span>
                )}
              </button>
            </li>
          )} */}
            {role_accesses && (
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "Note" ? "active" : ""}`}
                  id="pills-Note-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-Note"
                  type="button"
                  role="tab"
                  aria-controls="pills-Note"
                  aria-selected="false"
                  name="Note"
                  onClick={(e) => handleTabChange(e)}
                >
                  Notes
                </button>
              </li>
            )}
          </ul>
        </div>
        <div>
          <button
            aria-describedby={ids}
            variant="contained"
            onClick={handleClick}
          >
            <MoreVertIcon />
          </button>
          <Popover
            id={ids}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <div className="w-[170px] min-w-[170px] py-1 bg-[#FFFFFF]">
              <div
                className="flex px-[14px] py-2 hover:bg-[#F8F8F8] cursor-pointer items-center"
                onClick={(e) => {
                  handleDeleteClick();

                  handleClose();
                }}
              >
                <img
                  src={deleteIcon}
                  alt="delete"
                  className="mr-[14px] h-4 w-4"
                />
                <p className="font-medium text-[#3C556B] text-[14px] align-middle">
                  Delete
                </p>
              </div>
            </div>
          </Popover>
        </div>
      </div>
      <div className="program_scroll grow overflow-y-auto">
        <div className="tab-content h-full" id="pills-tabContent">
          {/* <div
            className={`h-full tab-pane fade ${
              activeTab === "dashboard" ? "show active" : ""
            }`}
            id="pills-dashboard"
            role="tabpanel"
            aria-labelledby="pills-dashboard-tab"
          >
            {activeTab === "dashboard" && <Dashbord projectId={id.id} />}
          </div> */}
          {/* <div
            className={`h-full tab-pane fade ${
              activeTab === "daily-updates" ? "show active" : ""
            }`}
            id="pills-daily-updates"
            role="tabpanel"
            aria-labelledby="pills-daily-updates-tab"
          >
            {activeTab === "daily-updates" && <Updates projectId={id.id} />}
          </div> */}
          <div
            className={`h-full tab-pane fade ${
              activeTab === "tasks" ? "show active" : ""
            }`}
            id="pills-tasks"
            role="tabpanel"
            aria-labelledby="pills-tasks-tab"
          >
            {activeTab === "tasks" && <TaskList projectId={id.id} />}
          </div>
          {/* <div
            className={`h-full tab-pane fade ${
              activeTab === "milestone" ? "show active" : ""
            }`}
            id="pills-milestone"
            role="tabpanel"
            aria-labelledby="pills-milestone-tab"
          >
              {activeTab === "milestone" && <Milestone projectId={id.id} />}
          </div> */}
          {/* <div
            className={`h-full tab-pane fade ${
              activeTab === "payment" ? "show active" : ""
            }`}
            id="pills-payment"
            role="tabpanel"
            aria-labelledby="pills-payment-tab"
          >
              {activeTab === "payment" && <Payment projectId={id.id} />}
          </div> */}
          <div
            className={`h-full tab-pane fade ${
              activeTab === "documents" ? "show active" : ""
            }`}
            id="pills-documents"
            role="tabpanel"
            aria-labelledby="pills-documents-tab"
          >
            {activeTab === "documents" && <Documents projectId={id.id} />}
          </div>
          <div
            className={`h-full tab-pane fade ${
              activeTab === "members" ? "show active" : ""
            }`}
            id="pills-members"
            role="tabpanel"
            aria-labelledby="pills-members-tab"
          >
            {activeTab === "members" && <Members projectId={id.id} />}
          </div>
          {/* <div
            className={`h-full tab-pane fade ${
              activeTab === "task-request" ? "show active" : ""
            }`}
            id="pills-task-request"
            role="tabpanel"
            aria-labelledby="pills-task-request-tab"
          >
              {activeTab === "task-request" && <TasksRequest projectId={id.id} setCount={setCount} />}
          </div> */}
          <div
            className={`h-full tab-pane fade ${
              activeTab === "Note" ? "show active" : ""
            }`}
            id="pills-Note"
            role="tabpanel"
            aria-labelledby="pills-Note-tab"
          >
            {activeTab === "Note" && <Note projectId={id.id} />}
          </div>
        </div>
      </div>
      <div>
        <NewModal
          title="Are You Sure?"
          onClose={() => setShowModal(false)}
          show={showModal}
        >
          <div className="modal-body add__cmp__form">
            <h6>Do you really want to delete this project?</h6>
            <h6 className="text-red-500 mt-3">
              Warning:This will delete all your details related to this project.
            </h6>
            <div className="add__close__section">
              <button
                type="button"
                className="bg-[#F5F5F5] text-[#5D5D5D] w-[fit-content] px-4 py-2 rounded-[12px] me-3"
                onClick={() => setShowModal(false)}
              >
                No
              </button>
              <button
                type="button"
                className="bg-[#267072] text-[#fff] border-[1px] flex items-center  w-[fit-content] px-3 py-2 rounded-[12px] whitespace-nowrap"
                onClick={confirmDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </NewModal>
      </div>
    </div>
  );
};

export default ProjectDetails;
